import React from "react";
import { Databox, LoadGraphic, Step } from "../components-static/Common";
import EmptyPageLayout from "../components-app/EmptyPageLayout";
import { Input, Button, TextButton } from "../components-static/Input";
import u from "../utilities/Utilities";
import "../styles/visitor-self-submission.scss";
import QRCode from "qrcode.react";

export default class VisitorSelfSubmission extends React.Component {
  state = {
    loading: false,
    loadText: "Submitting...",
    step: "register",
    token: "none",
    entryData: {},
    fields: [],
    error: "",
  };

  componentDidMount = () => {
    const token = u.getQuery(this.props, "token");
    if (token) {
      this.setState({
        token: token,
        step: "success",
        instantiated: true,
      });
    } else {
      u.post({
        url: "/noauth/get-visitor-selfsubmit-config",
        data: {},
        success: ({ tenantOptions, purposeOptions }) => {
          this.setState({
            fields: [
              {
                dataType: "box",
                field: "name",
                label: "Your Name",
                rules: { required: true },
              },
              {
                dataType: "box",
                field: "contactNo",
                label: "Contact No.",
                rules: { required: true, mobileNumber: true },
                info: "Allows building management to contact you in an event of an emergency",
              },
              {
                dataType: "box",
                field: "email",
                label: "Email",
                type: "email",
                rules: { required: true },
                info: "To send you an email link to the QR code required to passthrough the buildings turnstiles",
              },
              {
                dataType: "box",
                field: "companyName",
                label: "Company",
              },
              {
                dataType: "select",
                field: "tenantID",
                label: "Tenant",
                options: tenantOptions,
                rules: { required: true },
              },
              {
                dataType: "select",
                field: "purpose",
                label: "Purpose",
                options: purposeOptions,
                rules: { required: true },
              },
            ],

            instantiated: true,
          });
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  };

  onValidate = (fields) => {
    this.setState({ error: "" });
    const input = fields.map((item) => {
      return item.field;
    });
    const entryData = this.state.entryData;

    for (var i = 0; i < input.length; i++) {
      const current = this.refs[input[i]].validate();
      if (!current.valid) {
        this.setState({ error: current.value });
        return 0;
      }
    }

    this.setState({ loading: true, error: "", loadText: "Submitting..." });

    u.post({
      url: "/noauth/visitor-self-submit",
      data: entryData,
      success: ({ qrcodeToken }) => {
        window.history.replaceState("", "", `/guest?token=${qrcodeToken}`);
        this.setState({ step: "success", loading: false, token: qrcodeToken });
      },
      error: (error, status) => {
        this.setState({ error: error, loading: false });
      },
    });
  };

  onChange = (value, label, index) => {
    let entryData = this.state.entryData;
    entryData[label] = value;
    this.setState({ entryData: entryData });
  };

  onFocus = (field) => {
    if (field.scrollToBottom) {
      const objDiv = document.getElementById("root");
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  };

  render = () => {
    const { entryData, fields, token, step } = this.state;

    if (!this.state.instantiated) {
      return <div className="page-error">{this.state.error}</div>;
    }
    return (
      <EmptyPageLayout
        title="Visitor QR Code"
        url="/visitor-self-submission"
        className="self-sub-container"
        style={{
          backgroundColor: step == "register" ? "#fcfcf0" : "#17495a",
        }}
      >
        <div>
          <LoadGraphic active={this.state.loading} text={this.state.loadText} />

          <div
            className="content-container"
            style={{ textAlign: "center", color: "#000000" }}
          >
            <Step active={step == "register"}>
              <div>
                <img
                  src="/images/app/vita-dark.png"
                  style={{ width: "150px", margin: "20px auto" }}
                />
                <div
                  style={{
                    margin: "20px auto",
                  }}
                >
                  We are committed to protecting your personal data. For full
                  details on how your data is handled, please refer to our{" "}
                  <a href="/privacy-policy" rel="noopener">
                    <b>Privacy Policy</b>
                  </a>
                  .<br />
                  <br />
                  We collect, use, disclose and otherwise process your
                  information to, among other things, manage building access,
                  ensure safety and security and comply with legal obligations.
                  <br />
                  <br />
                  Please note that the asset is monitored by CCTV surveillance
                  24 hours a day.
                  <br />
                  <br />
                  To help us maintain a safe and secure environment, we kindly
                  ask that you complete the <b>visitor registration</b> form
                  below with all required information.
                </div>
                <div>
                  {fields.map((item, index) => {
                    return (
                      <Input
                        key={index}
                        ref={item.field}
                        fields={{
                          ...item,
                          onChange: this.onChange,
                        }}
                        onFocus={this.onFocus}
                        content={entryData}
                        style={{ margin: "20px auto", fontSize: "16px" }}
                      />
                    );
                  })}

                  <div
                    className="segment-buttons"
                    style={{
                      position: "relative",
                      marginTop: "30px",
                      textAlign: "center",
                    }}
                  >
                    <div className="page-error">{this.state.error}</div>

                    <TextButton
                      style={{ color: "#17495a" }}
                      onClick={() => {
                        this.onValidate(fields);
                      }}
                    >
                      Register
                    </TextButton>
                  </div>
                  <div style={{ margin: "20px auto" }}>
                    In the event of an emergency, please follow all instructions
                    provided by our on-site management and security teams to
                    ensure your safety and the safety of others.
                    <br />
                    <br />
                    <br />
                    This asset is managed by Vita Property Services Pte Ltd.
                  </div>
                </div>
              </div>
            </Step>

            <Step active={step == "success"} scrollAnchor="empty-root">
              <div style={{ color: "#fcfcf0" }}>
                <img
                  src="/images/app/vita-light.png"
                  style={{ width: "150px", margin: "20px auto" }}
                />

                <div>
                  Thanks for completing your visitor registration.
                  <br />
                  <br />
                  For full details on how your data is handled, please refer to
                  our{" "}
                  <a
                    href="/privacy-policy"
                    rel="noopener"
                    className="link-white"
                  >
                    <b>Privacy Policy</b>
                  </a>
                  . The premises are monitored by 24-hour CCTV.
                  <br />
                  <br />
                  In the event of an emergency, please follow all instructions
                  provided by our on-site management and security teams to
                  ensure your safety and the safety of others.
                  <br />
                  <br />
                  Please utilise the QR below to access the asset:
                </div>

                <div
                  style={{
                    position: "relative",
                    width: "200px",
                    height: "200px",
                    margin: "40px auto",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                >
                  <QRCode value={token} size={200} />
                </div>

                <div style={{ margin: "30px auto" }}>
                  This asset is managed by Vita Property Services Pte Ltd.
                </div>
              </div>
            </Step>
          </div>
        </div>
      </EmptyPageLayout>
    );
  };
}
